// extracted by mini-css-extract-plugin
export var navbarSubLink = "F_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "F_r5 d_f0 d_dB";
export var subPageLink = "F_gf d_gf";
export var burger = "F_t7";
export var sublinkSize = "F_t8";
export var linkSize = "F_t9";
export var Link = "F_r8 x_r8 x_r9 x_sv";